import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  mapContainer: {
    height: '100%',
    margin: -theme.spacing(1) * 3
  }
}));
